import { getMixpanel } from '@domain-group/fe-helper';
import { getBaseProps } from '..';
import getEntryPoint from '../get-entry-point';
import { getVisibleLandingPageModules } from './modules';
import type { FaaLandingPageModule } from './modules';

const trackViewLandingPage = (
  serverReferer?: string,
  modules: FaaLandingPageModule[] = getVisibleLandingPageModules(),
): void => {
  try {
    const mixpanel = getMixpanel();
    const entryPoint = getEntryPoint({ serverReferer });

    mixpanel.track('View FAA Landing Page', {
      ...getBaseProps(),
      entryPoint,
      siteSection: 'Agents',
      modules,
      modulesCount: modules.length,
    });
  } catch {
    throw new Error('Failed to track View FAA Landing Page event');
  }
};

export default trackViewLandingPage;
